import { Microfrontend } from '@cian/mf-react';

import { type FC } from 'react';

import { useModerationComplaint } from '../../hooks/useModerationComplaint';
import { ComplainsModalLoader } from '../ComplainsModalLoader';
import { ModalComplainsLoadError } from '../ModalComplainsLoadError';

type ComplaintModalContentProps = {
  onClose: () => void;
};

export const ComplaintModalContent: FC<ComplaintModalContentProps> = ({ onClose }) => {
  const data = useModerationComplaint(onClose);

  if (!data || !data.manifest) {
    return <ComplainsModalLoader />;
  }

  const { manifest, offerId, status, isFetching, refetch } = data;

  switch (status) {
    case 'success':
      return (
        <Microfrontend
          image={manifest.imageVersion}
          name={manifest.microfrontendName}
          parameters={{ offerId }}
          runtime={manifest.runtimeName}
        />
      );
    case 'error':
      return <ModalComplainsLoadError isLoading={isFetching} refetch={refetch} />;
    default:
      return null;
  }
};
